import { render, staticRenderFns } from "./AddAccountShift.vue?vue&type=template&id=498bc0ba"
import script from "./AddAccountShift.vue?vue&type=script&lang=js"
export * from "./AddAccountShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports